/**
 * Router -- Context provider for hash-based routing.
 *
 * Provides the current hash path and a navigate function to all descendants.
 * The Route and Switch components consume this context.
 */
import React, { createContext, useContext } from "react";
import { useHashLocation } from "./useHashLocation";

export interface RouterContextValue {
  path: string;
  navigate: (to: string) => void;
  /** Params extracted by the nearest matching Route */
  params: Record<string, string>;
}

export const RouterContext = createContext<RouterContextValue>({
  path: "/",
  navigate: () => {},
  params: {},
});

export function useRouterContext(): RouterContextValue {
  return useContext(RouterContext);
}

export function Router({ children }: { children: React.ReactNode }) {
  const [path, navigate] = useHashLocation();
  return (
    <RouterContext.Provider value={{ path, navigate, params: {} }}>
      {children}
    </RouterContext.Provider>
  );
}
